import React from 'react'
import HotelFacilitiesTable from './hotelFacilitiesTable.jsx'
import { object, string } from 'prop-types'

class ProductInformation extends React.Component {
  normaliseString (str) {
    // Replace HTML tags with spaces, replace all white spaces with single spaces, trim, convert to lower case, replace commas with nothing
    str = str.replace(/(<([^>]+)>)/ig, ' ')
      .replace(/\s\s+/g, ' ')
      .trim()
      .replace(/,/g, '')
    return str
  }

  addressInSEOContent () {
    const { productData: product, pageData } = this.props
    const normalisedAddress = this.normaliseString(product.address)
    if (normalisedAddress.length) {
      const normalisedContent = this.normaliseString(pageData.html)
      return normalisedContent.indexOf(normalisedAddress) > -1
    }
    return false
  }

  render () {
    const { productData: product = {}, id, pageData } = this.props
    let intro = ''
    const cpStory = typeof product.tripappcarparkstory === 'string' ? product.tripappcarparkstory : ''
    const productName = (typeof product.name === 'string' && product.name.length > 0) ? product.name : ''

    if (typeof product.tripappintroduction === 'string' && product.tripappintroduction.trim().length) {
      intro = product.tripappintroduction
    } else if (typeof product.introduction === 'string' && product.introduction.trim().length) {
      intro = product.introduction
    }

    return (
      <div id={id}>
        { intro.length > 0 && (
          <div dangerouslySetInnerHTML={{ __html: intro }} />
        )}
        { pageData.productClass === 'CP' && cpStory.trim().length > 0 && (
          <div dangerouslySetInnerHTML={{ __html: cpStory }} />
        )}
        { typeof product.address === 'string' && !this.addressInSEOContent() && (
          <div>
            { productName.length > 0 && (
              <h2>{ product.name + ' address' }</h2>
            ) }
            <div dangerouslySetInnerHTML={{ __html: product.address }} />
          </div>
        )}
        { (pageData.productClass === 'HO' || pageData.productClass === 'HCP') && (
          <HotelFacilitiesTable productData={product} productName={productName} />
        ) }
      </div>
    )
  }
}

ProductInformation.propTypes = {
  productData: object,
  pageData: object,
  id: string
}

ProductInformation.defaultProps = {
  productData: { }
}

export default ProductInformation



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/specificProduct/productInformation.jsx